// @ts-check
import React, { useContext } from 'react';
import Section from "@/src/shared/components/Section";
import usePublicSearch from "../../../hooks/usePublicSearch";
import BulletedListPage from "@/src/shared/components/BulletedPage/BulletedListPage";
import Heading from "@/src/shared/components/Heading";
import ListPagePaginated from "@/src/shared/components/ListPage/ListPagePaginated";
import Container from "@/src/shared/components/Container";
import ContentBody from "./ContentBody";
import ContentPageContext from "@/src/cms/context/ContentPageContext";

/**
 * @param {{
 *   children: import("react").ReactNode;
 *   bodyStyle?: any;
 * }} props
 */
export default function WithRelatedResults(props) {
  const { children, bodyStyle } = props;

  const value = useContext(ContentPageContext);

  if (!value) {
    throw new Error('WithRelatedResults must be wrapped with ContentPageContext.Provider or ContentPageContextProvider')
  }

  let { includeRelated, loading, sitepageid, body, relateResultsFieldOptions } = value;
  let heading = value.displayListTitle;
  let isBulletedFormat = value.bulletedFormat === 'Y'
  let position = value.displayListTop === 'Y' ? 'top' : 'bottom';
  let hasBody = Boolean(body)

  const { results, status } = usePublicSearch(relateResultsFieldOptions, includeRelated, loading);

  let list = null;
  if (includeRelated && status !== 'error') {
    let Component = isBulletedFormat ? BulletedListPage : ListPagePaginated;
    list = (
      <Component
        renderBeforeList={() => {
          return heading ? (
            <Heading style={{ marginBottom: '12px' }} type={3} theme="primaryRed">
              {heading}
            </Heading>
          ) : null;
        }}
        results={results}
        pageSize={isBulletedFormat ? undefined : 10}
        truncateResultSummary
        loading={status === 'pending' || status === 'idle'}
        noHero
      />
    )
  }

  return (
    <>
      {(position === 'top' && !isBulletedFormat) && (
        <Section bgColor="gray" halfPad>{list}</Section>
      )}

      {hasBody && (
        <Section bgColor="gray">
          <Container
            size="sm"
            style={{ fontSize: '1.6rem' }}
          >
            <ContentBody
              before={(position === 'top' && isBulletedFormat) && (
                <div style={{margin: '0 0 48px'}}>{list}</div>
              )}
              after={(position === 'bottom' && isBulletedFormat) && (
                <div style={{margin: '48px 0 0'}}>{list}</div>
              )}
              bodyStyle={bodyStyle}
            />
          </Container>
        </Section>
      )}

      {children}

      {(position === 'bottom' && !isBulletedFormat) && (
        <Section bgColor="gray" halfPad>{list}</Section>
      )}
    </>
  )
}